import { WikiSpecies } from '../../../core/types/wiki';

export const MOCK_SPECIES: WikiSpecies[] = [
  {
    id: 'tucunare-azul',
    slug: 'tucunare-azul',
    scientificName: 'Cichla piquiti',
    commonNames: ['Tucunaré Azul', 'Azulão', 'Piquiti'],
    shortDescription: 'O rei da pesca esportiva no Brasil. Explosivo, forte e belíssimo.',
    description: 'O Tucunaré Azul é uma das espécies mais cobiçadas da pesca esportiva brasileira. Conhecido por sua coloração vibrante em tons de azul e dourado, e por suas listras verticais escuras, este peixe é famoso por sua agressividade e força descomunal. É nativo da bacia Araguaia-Tocantins, mas foi amplamente introduzido em reservatórios do Sudeste e Centro-Oeste.',
    family: 'Cichlidae',
    maxWeight: 6.5,
    maxLength: 70,
    diet: ['carnivore'],
    habitat: 'Águas paradas, estruturas submersas, troncos e pedras.',
    distribution: ['Rio Tocantins', 'Rio Araguaia', 'Represa de Três Marias', 'Represa de Serra da Mesa', 'Rio Paranaíba'],
    bestBaits: ['Jigs', 'Iscas de Superfície (Zara, Stick)', 'Meia-água', 'Twitch Baits'],
    bestTechniques: ['Arremesso preciso', 'Trabalho rápido de ponta de vara', 'Stop and Go'],
    coverImage: 'https://images.unsplash.com/photo-1544551763-77ef2d0cfc6c?q=80&w=2070&auto=format&fit=crop', // Placeholder
    difficulty: 'medium'
  },
  {
    id: 'tucunare-acu',
    slug: 'tucunare-acu',
    scientificName: 'Cichla temensis',
    commonNames: ['Tucunaré Açu', 'Tucunaré Paca', 'Gigante da Amazônia'],
    shortDescription: 'O maior de todos os tucunarés. O troféu máximo da Amazônia.',
    description: 'O Tucunaré Açu é o maior membro do gênero Cichla e o maior ciclídeo das Américas. Pode ultrapassar os 10kg e é o principal alvo dos pescadores que vão à Amazônia. Apresenta duas fases de coloração distintas: a fase "Açu" (reprodutiva), com cores vivas e ocelos, e a fase "Paca" (não reprodutiva), mais escuro e com pintas brancas.',
    family: 'Cichlidae',
    maxWeight: 13,
    maxLength: 90,
    diet: ['carnivore'],
    habitat: 'Lagoas marginais, ressacas e igapós da Bacia Amazônica.',
    distribution: ['Rio Negro', 'Rio Madeira', 'Rio Tapajós', 'Rio Trombetas'],
    bestBaits: ['Hélices (Propellers)', 'Poppers Grandes', 'Jigs de 20g+', 'Meia-água de corpo grande'],
    bestTechniques: ['Arrasto contínuo com hélice', 'Trovão (barulho na superfície)'],
    coverImage: 'https://cdn.pixabay.com/photo/2021/01/29/18/31/peacock-bass-5961601_1280.jpg', 
    difficulty: 'hard'
  },
  {
    id: 'dourado',
    slug: 'dourado',
    scientificName: 'Salminus brasiliensis',
    commonNames: ['Dourado', 'Rei do Rio', 'Tigre del Rio'],
    shortDescription: 'O "Rei do Rio". Conhecido por seus saltos acrobáticos e mandíbula dura.',
    description: 'O Dourado é um peixe de escamas, de coloração dourada intensa e listras pretas laterais. É um predador voraz e muito forte. Sua pesca é desafiadora devido à sua boca óssea, o que dificulta a fisgada. Seus saltos fora d\'água são o ponto alto da batalha.',
    family: 'Characidae',
    maxWeight: 25,
    maxLength: 100,
    diet: ['carnivore'],
    habitat: 'Corredeiras, bocas de corrego, estruturas de pedra em rios de água corrente.',
    distribution: ['Bacia do Prata', 'Rio Paraná', 'Rio Paraguai', 'Rio Uruguai'],
    bestBaits: ['Colheres', 'Iscas de Barbela longa', 'Tuvira (iscas vivas)', 'Plugs de meia-água'],
    bestTechniques: ['Corrico', 'Arremesso nas corredeiras', 'Rodada com isca viva'],
    coverImage: 'https://pescaesportiva.com.br/wp-content/uploads/2020/01/dourado-peixe-pesca-esportiva.jpg', // Placeholder
    difficulty: 'hard'
  },
  {
    id: 'traira',
    slug: 'traira',
    scientificName: 'Hoplias malabaricus',
    commonNames: ['Traíra', 'Lobó'],
    shortDescription: 'Presente em todo o Brasil. Voraz, dentuça e divertida.',
    description: 'A Traíra é um dos peixes mais comuns do Brasil, encontrada em praticamente qualquer lagoa, represa ou brejo. Apesar de não crescer tanto quanto os tucunarés, é extremamente agressiva e ataca com violência iscas de superfície, proporcionando uma pescaria muito divertida e acessível.',
    family: 'Erythrinidae',
    maxWeight: 3,
    maxLength: 60,
    diet: ['carnivore'],
    habitat: 'Águas paradas, vegetação aquática, margens com estruturas.',
    distribution: ['Todo o território nacional'],
    bestBaits: ['Frogs (Sapos de borracha)', 'Spinnerbaits', 'Plugs de superfície'],
    bestTechniques: ['Trtrabalho lento em vegetação', 'Hoping (pulos) com frogs'],
    coverImage: 'https://i.pinimg.com/originals/e8/34/0c/e8340c26880277258482436214175375.jpg', // Placeholder
    difficulty: 'easy'
  },
  {
    id: 'robalo-peva',
    slug: 'robalo-peva',
    scientificName: 'Centropomus parallelus',
    commonNames: ['Robalo Peva', 'Robalinho'],
    shortDescription: 'O desafio dos mangues. Manhoso e técnico.',
    description: 'O Robalo Peva é um peixe de estuário e água salobra, mas que sobe muito os rios. É conhecido por ser um peixe "manhoso", exigindo técnica apurada e equipamentos leves. Sua carne é muito apreciada, mas na pesca esportiva vale pelo desafio de fisgá-lo em meio aos manguezais.',
    family: 'Centropomidae',
    maxWeight: 5,
    maxLength: 60,
    diet: ['carnivore'],
    habitat: 'Manguezais, estuários, foz de rios, pilares de pontes.',
    distribution: ['Costa Brasileira (Ambos os lados)', 'Rios costeiros'],
    bestBaits: ['Camarão artificial (Jig head)', 'Plugs de meia-água pequenos', 'Camarão vivo'],
    bestTechniques: ['Jigging', 'Arremesso de precisão nos galhos'],
    coverImage: 'https://upload.wikimedia.org/wikipedia/commons/e/e0/Centropomus_parallelus.jpg', // Placeholder
    difficulty: 'expert'
  }
];
